module.exports = __webpack_public_path__ + "static/media/edit-icon.8d205c21.svg";